import type { LyricsEntry, LyricsRowData, LyricsRenderConfig } from '@/data/Lyrics';
import Lyrics from '@/data/Lyrics';
import type { MetadataFormat } from '@/data/Metadata';
import type { Pixel, Unit } from '@/data';
import type { Image3DPageData } from '@/data/sources';
import MetadataParser from '../MetadataParser';
import type { ImageDimensions } from './SourceParser';

export interface LyricsFileFormat extends MetadataFormat{
  lyrics?: string;
  id?: string;
  name?: string;
}

export function lyricsFormatFromNewFormat(sourceFormat: Map<string, unknown>): LyricsFileFormat {
  const refs: Record<string, string> = {};
  (Array.from(sourceFormat.keys()) as string[]).filter((key) => key.startsWith('ref')).forEach((refKey) => { refs[refKey] = sourceFormat.get(refKey) as string; });

  return {
    lyrics: sourceFormat.get('lyrics') as string,
    info: sourceFormat.get('text') as string,
    license: sourceFormat.get('license') as string,
    contributors: sourceFormat.get('contributors') as Record<string, string>,
    refs,
    id: sourceFormat.get('id') as string,
    name: sourceFormat.get('name') as string,
    year: sourceFormat.get('year') as string,
  };
}

export default class LyricsParser extends Lyrics {
  static fromFormat(
    format: LyricsFileFormat,
    lyricsEntries: LyricsEntry[],
    pixelUnit: Unit<Pixel>,
    dim: ImageDimensions,
    pages: Image3DPageData[],
    renderRows: LyricsRowData[],
    renderConfig: LyricsRenderConfig,
  ): Lyrics {
    if (!lyricsEntries || lyricsEntries.length === 0) {
      throw new Error('No lyrics entries provided for parsing');
    }

    const metadata = MetadataParser.fromFormat(format);

    return new Lyrics({
      lyricsEntries,
      pixelUnit,
      height: dim.height,
      width: dim.width,
      pages,
      metadata,
      name: format.name,
      renderRows,
      renderConfig,
      isLinear: true,
    });
  }
}
